import { PureComponent, PropsWithChildren } from "react";

export default class CustomizeDataEditorPropertyValue extends PureComponent<PropsWithChildren> {
  render() {
    return (
      <div className="ct-customize-data-editor__property-value">
        {this.props.children}
      </div>
    );
  }
}
